/**
 * Standalone fetchWithAuth for use outside React hooks.
 * Uses backendToken from localStorage and handles network errors.
 */
export async function fetchWithAuth(url: string, options: any = {}) {
  const backendToken = window.localStorage.getItem('backendToken');
  try {
    const response = await fetch(url, {
      ...options,
      headers: {
        ...(options.headers || {}),
        Authorization: backendToken ? `Bearer ${backendToken}` : '',
      },
    });

    if (response.status === 403) {
      // Forbidden - could handle globally if needed
      // Optionally, set a flag or dispatch an event
    }
    if (response.status === 401) {
      // Unauthorized - clear token
      window.localStorage.removeItem('backendToken');
    }
    return response;
  } catch (error: any) {
    // Handle network errors
    if (
      error.name === 'TypeError' &&
      (error.message.includes('fetch') || error.message.includes('Failed to fetch'))
    ) {
      const networkError = new Error('Service temporarily unavailable');
      (networkError as any).isServiceUnavailable = true;
      throw networkError;
    }
    if (error.name === 'AbortError' || error.message.includes('timeout')) {
      const timeoutError = new Error('Service temporarily unavailable');
      (timeoutError as any).isServiceUnavailable = true;
      throw timeoutError;
    }
    if (
      error.message.includes('network') ||
      error.message.includes('connection') ||
      error.message.includes('ECONNREFUSED') ||
      error.message.includes('ENOTFOUND') ||
      error.message.includes('ENETUNREACH') ||
      error.message.includes('ERR_NETWORK') ||
      error.message.includes('ERR_INTERNET_DISCONNECTED')
    ) {
      const networkError = new Error('Service temporarily unavailable');
      (networkError as any).isServiceUnavailable = true;
      throw networkError;
    }
    throw error;
  }
}
